"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleQuestionMark, ArrowRight } from "lucide-react";
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const ownerQuestions = [{
    question: "How do you handle tenant placement?",
    answer: "We utilize a comprehensive screening process that includes background checks, credit evaluations, and rental history verification. Our goal is to find reliable tenants who will treat your property with respect while ensuring consistent occupancy rates."
  }, {
    question: "What is included in your property management services?",
    answer: "Our full-service management includes marketing your property, tenant screening, lease execution, rent collection, maintenance coordination, and detailed financial reporting. We handle the day-to-day operations so you can enjoy the benefits of ownership without the stress."
  }, {
    question: "How are maintenance requests handled?",
    answer: "We have a dedicated team and a network of trusted local contractors to handle both routine maintenance and emergency repairs. We coordinate everything, ensuring work is done promptly and cost-effectively, keeping you informed every step of the way."
  }, {
    question: "Do you provide financial reporting for owners?",
    answer: "Yes, we provide transparent, detailed monthly financial statements. You can access reports on income, expenses, and overall property performance at any time through our secure owner portal."
  }];
  const renterQuestions = [{
    question: "How do I apply for a rental property?",
    answer: "You can browse our available listings on our 'Find a Home' page and submit an application directly online. Our process is streamlined to make it as easy as possible for you to find your next home."
  }, {
    question: "What are the lease terms available?",
    answer: "We offer both short-term and long-term lease options to accommodate different needs. Whether you need a temporary furnished rental or a long-term unfurnished home, we have flexible options available."
  }, {
    question: "What is your pet policy?",
    answer: "Pet policies vary by property depending on the owner's preferences. Many of our homes are pet-friendly with a required pet deposit. Please check the specific listing details or contact us for more information about a specific property."
  }, {
    question: "How do I pay my rent?",
    answer: "We offer a convenient online tenant portal where you can securely pay rent, view your payment history, and submit maintenance requests 24/7 from your computer or mobile device."
  }];
  return;
}